import { useContext } from "react";
import { FieldStateDataContext } from "../providers/FieldDataContext";

const useFieldState = () => {
  const context = useContext(FieldStateDataContext);
  if (context === undefined) {
    throw new Error("must be used within a <FieldDataProvider/>");
  }
  return context;
};

export default useFieldState;
